import { render, staticRenderFns } from "./quiz-configration.html?vue&type=template&id=23cea8a7&scoped=true&"
import script from "./quiz-configration.vue?vue&type=script&lang=js&"
export * from "./quiz-configration.vue?vue&type=script&lang=js&"
import style0 from "./quiz-configration.css?vue&type=style&index=0&id=23cea8a7&prod&scoped=true&lang=css&"
import style1 from "./config-loader.css?vue&type=style&index=1&id=23cea8a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cea8a7",
  null
  
)

export default component.exports